import { Metadata } from "next";
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export function absoluteUrl(path: string) {
  if (typeof window !== "undefined") return path;
  const baseUrl = process.env.NEXT_PUBLIC_APP_URL
    ? process.env.NEXT_PUBLIC_APP_URL
    : `http://localhost:3000`;
  return `${baseUrl}${path}`;
}

export function constructMetadata({
  title = "raffaello - Your AI Web Developer",
  description = "Unleash your creativity with the help of raffaello to create, edit, monitor stunning websites and web applications.",
  image = "/thumbnail.png",
  icons = "/favicon.ico",
  noIndex = false, // allow search engine bots to crawl and index the website
}: {
  title?: string;
  description?: string;
  image?: string;
  icons?: string;
  noIndex?: boolean;
} = {}): Metadata {
  return {
    title,
    description,
    openGraph: {
      title,
      description,
      images: [
        {
          url: image,
        },
      ],
    },
    twitter: {
      card: "summary_large_image",
      title,
      description,
      images: [image],
      creator: "@nabarvn",
    },
    icons,
    metadataBase: new URL("https://raffaello.dev/"),
    ...(noIndex && {
      robots: {
        index: false,
        follow: false,
      },
    }),
  };
}


export function downloadStringAsFile(
  content: string,
  mimeType: string,
  projectName: string
) {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = projectName;
  document.body.append(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const MOBILE_WIDTH = 580;

export async function fetchDemoProject(): Promise<any> {
  return {
    projectId: "demo",
    name: "Demo Project",
    userId: "demo-user",
    githubRepoId: null,
    templateUrl: null,
    createdAt: new Date("2025-01-01T00:00:00Z"),
    updatedAt: new Date("2025-01-05T00:00:00Z"),
    branch: "main",
    githubUrl: null,
    description: "This is a sample demo project for showcasing the editor.",
    industry: "Technology",
    thumbnailUrl: null,
    websiteUrl: "https://example.com/demo",
    logoUrl: null,
    tags: ["demo", "template", "preview"],
    tech: ["Next.js", "TailwindCSS", "TypeScript"],
    pages: ["/index", "/about", "/contact"],
    lastCommitedAt: new Date("2025-01-04T18:00:00Z"),
    lastCommitedBy: "demo-user",
    lastCommitedMessage: "Initial demo commit",

  };
}